import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface ISearchInfoModel {
    destroy: () => void;
    // 0 为搜索，1 为非搜索
    is_search: string;
    // 分类
    class: string;
    // 关键词
    query: string;
    // 算法
    scm: string;

    setISearchInfo: (payload: {
        is_search: string;
        // 分类
        class: string;
        // 关键词
        query: string;
        // 算法
        scm: string;
    }) => void;
    setIsSearch: (payload: string) => void;
    setClass: (payload: string) => void;
    setQuery: (payload: string) => void;
    setScm: (payload: string) => void;
}
const useSearchModel = create<ISearchInfoModel>()(
    immer((set) => ({
        destroy: () =>
            set((state) => {
                state.is_search = '0';
                state.class = '';
                state.query = '';
                state.scm = '';
            }),
        is_search: '0',
        class: '',
        query: '',
        scm: '',
        setISearchInfo: (payload) =>
            set((state) => {
                state.is_search = payload.is_search || '';
                state.class = payload.class || '';
                state.query = payload.query || '';
                state.scm = payload.scm || '';
            }),
        setIsSearch: (payload) =>
            set((state) => {
                state.is_search = payload;
            }),
        setClass: (payload) =>
            set((state) => {
                state.class = payload;
            }),
        setQuery: (payload) =>
            set((state) => {
                state.query = payload;
            }),
        setScm: (payload) =>
            set((state) => {
                state.scm = payload;
            }),
    })),
);

export { useSearchModel };
export const getSearchModel = () => useSearchModel.getState();
